import axios from 'axios';
import cookie from '../cookieHelper/cookie'; 

const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/story/rawStory`;

export default function getRawStories() {
    // Retrieve the token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);


    return (
        axios.get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            // console.log('resstories: ', res);
            return res.data;
        })
        .catch(err => {
            // console.error('Error fetching raw stories: ', err);
            return err;
        })
    );
}
